<script setup>
    const { $bus } = useNuxtApp();
    const { enableMarker } = useRuntimeConfig().public;
    const route = useRoute();
    const hasIntro = 'intro' in route.query;

    const showIntroAnimation = shallowRef(false);
    const couldShowIntroAnimation = shallowRef(true);
    const animatedCompleted = shallowRef(false);

    const STORAGE_KEY = 'unbound-intro-seen';

    if (enableMarker) {
        useHead({
            script: [
                {
                    innerHTML: `
                  window.markerConfig = {
                      project: '69b313e3f0e086860a6a9933',
                      source: 'snippet'
                  };
                  !function(e,r,a){if(!e.__Marker){e.__Marker={};var t=[],n={__cs:t};["show","hide","isVisible","capture","cancelCapture","unload","reload","isExtensionInstalled","setReporter","clearReporter","setCustomData","on","off"].forEach(function(e){n[e]=function(){var r=Array.prototype.slice.call(arguments);r.unshift(e),t.push(r)}}),e.Marker=n;var s=r.createElement("script");s.async=1,s.src="https://edge.marker.io/latest/shim.js";var i=r.getElementsByTagName("script")[0];i.parentNode.insertBefore(s,i)}}(window,document);
              `,
                },
            ],
        });
    }

    function onCompleteAnimation() {
        showIntroAnimation.value = false;
        couldShowIntroAnimation.value = false;
        animatedCompleted.value = true;
        $bus.emit('intro-complete');
    }

    function onStartedAnimation() {
        couldShowIntroAnimation.value = false;
        localStorage.setItem(STORAGE_KEY, '1');
    }

    const pathSegments = route.path.split('/').filter(Boolean);
    const isDeepLink = pathSegments.length > 1 || 'drawer' in route.query || 'modal' in route.query;

    // Set by ProjectPage from the Builder page's hideHeaderFooter flag.
    const chromeHidden = useState('page-chrome-hidden', () => false);

    onMounted(async () => {
        // A page with its header and footer hidden is a bare embed, so the
        // intro does not play over it (Shannon, Asana 1217652819820640).
        // Deliberately does NOT write STORAGE_KEY, unlike the deep-link branch
        // below: an embed is not the visitor's entry to the site, and marking
        // the intro "seen" here would silently rob them of it on the real first
        // visit later. `?intro=` still forces it, for previewing.
        if (chromeHidden.value && !hasIntro) {
            animatedCompleted.value = true;
            couldShowIntroAnimation.value = false;
            $bus.emit('intro-complete');
        } else if (isDeepLink && !hasIntro) {
            animatedCompleted.value = true;
            couldShowIntroAnimation.value = false;
            localStorage.setItem(STORAGE_KEY, '1');
            $bus.emit('intro-complete');
        } else if (hasIntro) {
            showIntroAnimation.value = true;
        } else if (!localStorage.getItem(STORAGE_KEY)) {
            showIntroAnimation.value = true;
        } else {
            animatedCompleted.value = true;
            couldShowIntroAnimation.value = false;
            $bus.emit('intro-complete');
        }
    });
</script>

<template>
    <div class="not-ready" :class="[!couldShowIntroAnimation && 'ready', animatedCompleted && 'will-be-ready']">
        <FragmentsIntroAnimation v-if="showIntroAnimation" @complete="onCompleteAnimation" @started="onStartedAnimation" />
        <div class="inner-body">
            <slot />
        </div>
        <TwoSixBottomBanners />
    </div>
</template>

<style scoped>
    .not-ready .inner-body {
        opacity: 0;
        overflow: hidden;
        transition: opacity 0.2s linear;
        will-change: opacity;
    }

    .not-ready.will-be-ready .inner-body {
        opacity: 1;
        overflow: visible;
    }

    .not-ready.ready .inner-body {
        opacity: 1;
    }
</style>
